<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"
                            v-bind:title="$t('labels.collapse')">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Tên giải thi đấu thể thao" :options="category_GIAITHIDAU"
                                :initialValue="modelSearch.thethaoGiaithidauId" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(e) => { modelSearch.thethaoGiaithidauId =  e ? e : null; handlePageChange(1) }" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Tên bộ môn thể thao" :options="category_BOMON"
                                :initialValue="modelSearch.thethaoBomonId" :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                @onChange="(e) => { modelSearch.thethaoBomonId = e ? e : null; handlePageChange(1) }" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Tên thành tích thể thao" :options="category_THANHTICH"
                                :initialValue="modelSearch.thethaoThanhtichId" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(e) => { modelSearch.thethaoThanhtichId = e ? e : null; handlePageChange(1) }" />

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-tag"></i>&nbsp;
                    </h3>
                    <div class="card-tools">
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>

                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th class="col10"></th>
                                    <th class="col50 cursor" @click="handleSortChange('tenThethaoGiaithidau')">
                                        Giải thi đấu
                                        <span v-if="(orderDesc == false && sortBy == 'tenThethaoGiaithidau')"
                                            aria-hidden="true" class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'tenThethaoGiaithidau')"
                                            aria-hidden="true" class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50 cursor" @click="handleSortChange('tenThethaoBomon')">
                                        Bộ môn
                                        <span v-if="(orderDesc == false && sortBy == 'tenThethaoBomon')"
                                            aria-hidden="true" class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'tenThethaoBomon')"
                                            aria-hidden="true" class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col50 cursor" @click="handleSortChange('tenThethaoThanhtich')">
                                        Thành tích
                                        <span v-if="(orderDesc == false && sortBy == 'tenThethaoThanhtich')"
                                            aria-hidden="true" class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'tenThethaoThanhtich')"
                                            aria-hidden="true" class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col10">Số lượng</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item._id">
                                    <td></td>
                                    <td>{{ item.tenThethaoGiaithidau }}</td>
                                    <td>{{ item.tenThethaoBomon }}</td>
                                    <td>{{ item.tenThethaoThanhtich }}</td>
                                    <td>{{ item.soLuong }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
import TheInputText from '@/components/shareComponents/TheInputText.vue';
import TheSelect from '@/components/shareComponents/TheSelect.vue';

import { thanhTichTongHopTheThaoVHModel } from '@/models/thethao/thanhTichTongHopTheThaoVH.model'

export default {
    name: "TheThanhTichTongHopTheThaoVH2",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,
    },
    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],

            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,

            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,

            sValue_GIAITHIDAU: null,
            sValue_BOMON: null,
            sValue_THANHTICH: null,
            sValue_SORT: null,

            modelSearch: thanhTichTongHopTheThaoVHModel.newPagingSearchModel(),

            category_GIAITHIDAU: [],
            category_BOMON: [],
            category_THANHTICH: [],
        }
    },
    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('validate', ['validateRequired', 'validateNumber'],),
        //...mapActions('adjustData', ['formatDateShow', 'fromDatetoString']),
        ...mapActions('thanhTichTongHopTheThaoVH', ['getPagingCustomsThanhTichTongHopTheThaoVH']),
        ...mapActions('giaiThiDauTheThaoVH', ['getBasicGiaiThiDauTheThao']),
        ...mapActions('boMonTheThaoVH', ['getBasicBoMonTheThaoVH']),
        ...mapActions('thanhTichThiDauTheThaoVH', ['getBasicThanhTichTheThaoVH']),




        async setup() {
            let header = 'Danh sách thành tích tổng hợp thể thao'
            this.setupHeader({ header })
        },

        async initialize() {
            this.category_GIAITHIDAU = await this.getCategory_GiaiThiDau()
            this.category_BOMON = await this.getCategory_BoMon()
            this.category_THANHTICH = await this.getCategory_ThanhTich()
        },


        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                    this.modelSearch.sort = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },
        async onSearchKey() {
            this.pageNumber = config.CURRENT_PAGE
            await this.getData()
        },





        async searchChangeGiaiThiDau(e) {
            this.sValue_GIAITHIDAU = e == "" ? null : e
            this.handlePageChange(1)
        },
        async searchChangeBoMon(e) {
            this.sValue_BOMON = e == "" ? null : e
            this.handlePageChange(1)
        },
        async searchChangeThanhTich(e) {
            this.sValue_THANHTICH = e == "" ? null : e
            this.handlePageChange(1)
        },

        async standardizationFilter() {
            this.modelSearch.pageNumber = this.pageNumber
            this.modelSearch.pageSize = this.pageSize
        },
        async getData() {
            this.isBusy = true
            await this.standardizationFilter()
            await this.getPagingCustomsThanhTichTongHopTheThaoVH({ params: this.modelSearch }).then(res => {
                // List data
                this.items = res.data

                // // Total row
                this.totalRow = res.totalRow
                // // Number show
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                // // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },

        async getCategory_GiaiThiDau() {
            let params = {

            }
            let res = await this.getBasicGiaiThiDauTheThao({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].thethaoGiaithidauId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return []
        },

        async getCategory_BoMon() {
            let params = {

            }
            let res = await this.getBasicBoMonTheThaoVH({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].thethaoBomonId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return []
        },

        async getCategory_ThanhTich() {
            let params = {

            }
            let res = await this.getBasicThanhTichTheThaoVH({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].thethaoThanhtichId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return []
        },
    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()
    }


}
</script>
<style></style>